import { format, parseISO, startOfWeek, addWeeks, addDays, getISOWeek, getISOWeekYear, isSameDay } from 'date-fns';
import { de } from 'date-fns/locale';

export const fmtDate = (d) => {
  if (!d) return '';
  const dt = typeof d === 'string' ? parseISO(d) : d;
  return format(dt, 'dd.MM.yyyy', { locale: de });
};

export const fmtDateShort = (d) => {
  if (!d) return '';
  const dt = typeof d === 'string' ? parseISO(d) : d;
  return format(dt, 'dd.MM.', { locale: de });
};

export const fmtDateTime = (d) => {
  if (!d) return '';
  const dt = typeof d === 'string' ? parseISO(d) : d;
  return format(dt, 'dd.MM.yyyy HH:mm', { locale: de });
};

export const fmtWeekday = (d) => {
  if (!d) return '';
  const dt = typeof d === 'string' ? parseISO(d) : d;
  return format(dt, 'EEEE', { locale: de });
};

export const fmtWeekdayShort = (d) => {
  if (!d) return '';
  const dt = typeof d === 'string' ? parseISO(d) : d;
  return format(dt, 'EEE', { locale: de });
};

export const isoDate = (d) => {
  const dt = typeof d === 'string' ? parseISO(d) : d;
  return format(dt, 'yyyy-MM-dd');
};

export const weekStart = (d) => startOfWeek(d, { weekStartsOn: 1 });

export const buildWeeks = (anchorDate, numberOfWeeks) => {
  const result = [];
  const firstMonday = weekStart(anchorDate);
  for (let i = 0; i < numberOfWeeks; i++) {
    const mondayOfWeek = addWeeks(firstMonday, i);
    const days = [];
    for (let d = 0; d < 6; d++) {
      days.push(addDays(mondayOfWeek, d));
    }
    result.push({
      isoWeek: getISOWeek(mondayOfWeek),
      isoYear: getISOWeekYear(mondayOfWeek),
      monday: mondayOfWeek,
      days,
    });
  }
  return result;
};

export { addDays, addWeeks, isSameDay, parseISO, getISOWeek };
